import gql from 'graphql-tag';

export default gql`
    query GetEquipmentLoggers($input: EquipmentLoggerSearchInput) {
        getEquipmentLoggers(input: $input) {
            id
            message
            creationDate
            createdBy
            creatorName
            assetLoadId
            systemType
        }
    }
`;
